import React from "react";

export default function AboutCompany() {
  return (
    <section className="w-full pt-16 md:pt-[130px] pb-16 md:pb-[130px]">
      <div className="w-full mx-auto theme-container px-4">
        <div className="grid grid-cols-6 gap-6 sm:gap-10 lg:grid-cols-12 lg:gap-0 h-fit">
          <div className="col-span-6 lg:pr-[64px] flex h-full items-center">
            <div className="">
            <h1 className="border text-chip border-purple/30 py-0.5 px-5 rounded-[30px] w-fit mb-5 text-sm sm:text-base">
                About Impera
              </h1>
              <h2 className="text-34 sm:text-34 md:text-48 font-semibold text-white mb-8 sm:mb-[50px] md:w-[80%] w-full xl:w-full">
                Transforming Business Through Hyperautomation
              </h2>
              <p className="text-paragraph mb-8 sm:mb-[50px] text-sm sm:text-base">
              Impera was founded in 2023 by a core team with decades of experience in Digital Transformation, Process Automation, and Cloud services. With teams working from the Caribbean and India. Impera serves customers in North America and Latin America. 
              </p>
              <hr className="mt-8 sm:mt-10 border-purple/30" />
              <div className="w-full grid grid-cols-1 sm:grid-cols-2 mt-8 sm:mt-[50px] gap-6 sm:gap-8 md:gap-[70px]">
                <div data-aos="fade-left" className="grid-cols-1">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10Z"
                      fill="#2423EF"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M14.4605 6.40802C14.7874 6.66232 14.8463 7.13353 14.592 7.46049L10.585 12.6123C9.9613 13.4143 8.78809 13.5183 8.03296 12.8387L5.49828 10.5575C5.1904 10.2804 5.16544 9.80619 5.44254 9.49831C5.71963 9.19043 6.19385 9.16547 6.50173 9.44256L9.03641 11.7238C9.14429 11.8209 9.31189 11.806 9.40099 11.6914L13.408 6.53958C13.6623 6.21262 14.1335 6.15372 14.4605 6.40802Z"
                      fill="white"
                    />
                  </svg>
                  <h1 className="mt-4 font-semibold text-16 sm:text-18 text-white">
                  Mission & Vision: 
                  </h1>
                  <p className="mt-3 text-paragraph text-sm sm:text-base">
                  Impera's mission is unlocking real enterprise value from technology and delivering top-tier customer service.
                  </p>
                </div>
                <div
                  data-aos="fade-left"
                  data-aos-delay="100"
                  className="grid-cols-1"
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10Z"
                      fill="#2423EF"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M14.4605 6.40802C14.7874 6.66232 14.8463 7.13353 14.592 7.46049L10.585 12.6123C9.9613 13.4143 8.78809 13.5183 8.03296 12.8387L5.49828 10.5575C5.1904 10.2804 5.16544 9.80619 5.44254 9.49831C5.71963 9.19043 6.19385 9.16547 6.50173 9.44256L9.03641 11.7238C9.14429 11.8209 9.31189 11.806 9.40099 11.6914L13.408 6.53958C13.6623 6.21262 14.1335 6.15372 14.4605 6.40802Z"
                      fill="white"
                    />
                  </svg>
                  <h1 className="mt-4 font-semibold text-16 sm:text-18 text-white">
                  Core Values:
                  </h1>
                  <p className="mt-3 text-paragraph text-sm sm:text-base">
                  Transparency, Integrity, Results Oriented, People First. We take on our customer's challenges and ideas as our own.
                  </p>
                 </div>
              </div>
            </div>
          </div>

          <div className="relative flex flex-col items-center justify-end col-span-6 sm:flex-row mt-8 sm:mt-0">
            <div className="overflow-hidden rounded-2xl">
              <img
                src="./assets/images/about/aboutus.webp"
                alt="img"
                className="w-full h-auto"
              />
            </div>

            <div className="h4_contact_bg p-6 sm:p-[30px] rounded-2xl sm:absolute z-20 bottom-8 w-full sm:w-[295px] left-0 sm:left-8 mt-5 sm:mt-0 max-w-full">
              <img
                src="/assets/images/home-five/hero/about-card-shape.webp"
                alt=""
                className="absolute right-2 top-bottom-moving"
              />
              <div className="flex items-center gap-2.5">
                <svg
                  width="11"
                  height="12"
                  viewBox="0 0 11 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.28753 7.01343L8.90454 1.36956M8.90454 1.36956L3.26066 1.75255M8.90454 1.36956L1.01321 10.4099"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <span className="text-sm leading-8 text-white">Founded in</span>
              </div>
              <h1
                className="text-20 sm:text-[27px] leading-6 sm:leading-[35px] text-white font-semibold tracking-tight max-w-[170px]"
                data-scroll-qs="scroll"
                data-count-qs="25"
                data-type-qs="+ Years of Experience"
                data-speed-qs="1000"
              >
               2023
              </h1>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
